import React, { useState, useRef, useEffect } from 'react'
import { Typography, withStyles, Select, MenuItem } from '@material-ui/core'
import { useSelector } from 'react-redux'
import styles from './styles'
import { track } from '@amplitude/analytics-browser'

const AddCollection = props => {
  const { classes, onSave, currentCollections = '' } = props

  const [selectedCollection, setSelectedCollection] = useState('')
  const [menuWidth, setMenuWidth] = useState(0)

  const selectRef = useRef(null)
  useEffect(() => {
    const setWidth = () => {
      if (selectRef.current) {
        setMenuWidth(selectRef.current.offsetWidth)
      }
    }
    setWidth()
    window.addEventListener('resize', setWidth)
    return () => {
      window.removeEventListener('resize', setWidth)
    }
  }, [])

  const list = useSelector(state => state.collection.list)
  const collection = useSelector(state => state.collection.collection)
  const currentCollectionIds = currentCollections
    ? currentCollections
        .split(',')
        .map(id => id.trim())
        .filter(id => id)
    : []
  const availableCollections = list.filter(
    item =>
      !currentCollectionIds.includes(item.id) && item.id !== collection?.id,
  )

  const handleCollectionChange = e => {
    const newValue = e.target.value
    setSelectedCollection(newValue)
    track('collection_selected', { collectionId: newValue })

    if (onSave && typeof onSave === 'function') {
      onSave(newValue)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.section}>
        <div>
          <Typography fontSize="14px" fontWeight={400} color="#002E47">
            Select the learning path you want to add to the block from the list
          </Typography>
        </div>
        <div style={{ marginTop: '16px' }}>
          <Typography fontSize="13px" fontWeight={500} color="#002E47">
            Learning path
          </Typography>
        </div>
        <div className={classes.selectCollection} ref={selectRef}>
          <Select
            value={selectedCollection}
            onChange={handleCollectionChange}
            label=""
            className={classes.select}
            displayEmpty
            disableUnderline={true}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 48 * 5,
                  width: menuWidth,
                },
                sx: {
                  '& .MuiMenuItem-root': {
                    marginLeft: '8px',
                    marginRight: '8px',
                    borderRadius: '8px',
                    marginTop: '4px',
                    marginBottom: '4px',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-focusVisible': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected': {
                      backgroundColor: 'transparent',
                    },
                    '&.Mui-selected:hover': {
                      backgroundColor: 'transparent',
                    },
                  },
                },
              },
            }}
          >
            <MenuItem value="" disabled>
              <Typography
                className={classes.placeholder}
                color="#919EAB"
                fontWeight={400}
              >
                {availableCollections.length === 0
                  ? 'No learning paths available'
                  : 'Select the Learning path'}
              </Typography>
            </MenuItem>
            {availableCollections.map(item => (
              <MenuItem key={item.id} value={item.id}>
                <div className={classes.menuItem}>
                  <Typography className={classes.placeholder} fontWeight={400}>
                    {item.name}
                  </Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles)(AddCollection)
